export default "__VITE_ASSET__4c2757d9__"